/**
 * Shared shell for the superadmin queue-monitoring family (Queue workers +
 * every per-jobType job list) — same shape as TabbedSettingsPage, reusing
 * the same generic SettingsTabs strip (not settings-specific despite the
 * name/location) instead of the family's own hand-rolled QueueTabs.
 *
 * No `actions` prop, same as TabbedSettingsPage: per-tab buttons (Refresh,
 * Clean queue, Start new worker) live in that tab's own Card.Header, not
 * the page-level title row — see OrganizationMembersPage/MembersCard for
 * the established pattern.
 *
 * @param {string} title
 * @param {ReactNode} children
 */
import React from "react";
import PageTemplate from "../PageTemplate";
import PageHeader from "../AppShell/PageHeader/PageHeader";
import SettingsTabs from "../AppShell/SettingsTabs/SettingsTabs";
import { QUEUE_TABS } from "./queueTabs";
import styles from "./QueueTabsPageTemplate.module.scss";

const QueueTabsPageTemplate = ({ title, children }) => (
  <PageTemplate>
    <PageHeader
      breadcrumbs={[{ label: "Queues", to: "/queue-workers" }, { label: title }]}
      title={title}
      noDivider
    />
    <SettingsTabs tabs={QUEUE_TABS} />
    <div className={styles.body}>{children}</div>
  </PageTemplate>
);

export default QueueTabsPageTemplate;
